import { ColumnsType } from 'antd/es/table'
import { SortOrder } from 'antd/es/table/interface'
import { Sorter } from 'components/Sorter/Sorter'
import { AddressCell } from 'components/AddressCell/AddressCell'
import { fullFormatPhoneNumber } from 'helper/common'
import { GpoMenu } from './Menu/Menu'
import { GPOItem } from './types'
import { Link } from '../../../components/Link'
import { routes } from '../../../router'

export const columns: ColumnsType<GPOItem> = [
  {
    dataIndex: 'name',
    key: 'name',
    width: 320,
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<GPOItem>
        dataIndex="name"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        GPO name
      </Sorter>
    ),
    sorter: true,
    showSorterTooltip: false,
    render: (_, { uuid, name }) => (
      <Link to={`${routes.gpo}/${uuid}`}>{name}</Link>
    )
  },
  {
    dataIndex: 'phone_number',
    key: 'phone_number',
    width: 152,
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<GPOItem>
        dataIndex="phone_number"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        Phone number
      </Sorter>
    ),
    render: (_, { phone_number }) =>
      phone_number ? fullFormatPhoneNumber(phone_number) : '-',
    sorter: true,
    showSorterTooltip: false
  },
  {
    dataIndex: 'address',
    key: 'address',
    width: 240,
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<GPOItem>
        dataIndex="address"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        Address
      </Sorter>
    ),
    render: (_, { address }) =>
      address ? <AddressCell address={address} /> : '-',
    sorter: true,
    showSorterTooltip: false
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    width: 40,
    fixed: 'right',
    render: (_, row) => <GpoMenu uuid={row.uuid} />
  }
]
